import React, { Component } from 'react';

class Education extends Component {
  render() {
    if(!this.props.data){
      return null;
    }

    var education = this.props.data.map(function(item){
      return <div key={item.school}>
        <h3>{item.school}</h3>
        <p className="info">{item.degree} <span>&bull;</span><em className="date">{item.graduated}</em></p>
        <p>{item.description}</p>
      </div>;
    });

    return (
      <section id="education-section">
        <div className="row education-row">
          <div className="three columns header-col">
            <h1><span>Education</span></h1>
          </div>

          <div className="nine columns main-col">
            <div className="row item">
              <div className="twelve columns">
                {education}
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Education;



// WEBPACK FOOTER //
// ./src/Components/Education.js